/* eslint-disable no-debugger */
import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import {
  message,
  Input,
  Button,
  Form,
  Space,
  Tooltip,
  Drawer,
  Select,
  Tag,
  Card,
  Modal,
  Steps,
  TreeSelect,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  ExclamationCircleFilled,
  UserOutlined,
  SolutionOutlined,
  SmileOutlined,
  MehOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import {
  deleteApplication,
  getPagingApplication,
  updateApplication,
  deleteManyApplication,
  getManagementApplication,
  updateDepartmentUser,
} from "../../helpers/helper";
import { statusOptions } from "../../helpers/common";
import DataTable from "../../Components/Common/DataTable";
import ModalInfomation from "./Components/ModalInfomation";
import { extractManyId, extractTwoIds } from "../../common/function";

const { confirm } = Modal;
const { TreeNode } = TreeSelect;
const ApplicationManagement = () => {
  const { t } = useTranslation();
  document.title = t("menuManagerApply");

  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [listAction, setListAction] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [listCompany, setListCompany] = useState([]);
  const [showModalInfomation, setShowModalInfomation] = useState(false);
  const [infomationUser, setInfomationUser] = useState(false);

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
  const [treeDataDepartment, setTreeDataDepartment] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState({});

  const getAllData = async (_prams, indexPage) => {
    try {
      const params = _prams
        ? _prams
        : {
            pageIndex: indexPage,
            pageSize: pageSize,
            search: "",
          };

      const dataRes = await getPagingApplication(params);
      setTotalPage(dataRes?.totalPages);
      if (!dataRes) {
        message.error(t("requiredPermission"));
        return false;
      }

      const data = convertDataTable(dataRes.data);
      return dataRes?.data ? data : [];
    } catch (error) {
      message.error(t("requiredPermission"));
      setTotalPage(0);
      return [];
    }
  };

  const convertDataTable = (dataArray) => {
    const data =
      dataArray.length > 0 &&
      dataArray.map((item) => {
        return {
          key: item._id,
          createdBy: item?.createdBy?.username,
          createdById: item?.createdBy?._id,
          createdByInfo: item?.createdBy,
          companyName: item?.company?.companyName,
          companyId: item.company?._id || null,
          departmentName: item.department?.departmentName,
          departmentId: item.department?._id || null,
          groupId: item.group?._id || null,
          groupName: item.group?.groupName,
          status: item.status,
          userStatus: item?.status === 3 ? true : false,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
          updatedTime: item.updatedTime
            ? moment(new Date(item.updatedTime)).format("DD/MM/YYYY HH:mm")
            : "",
          updatedBy: item?.updatedBy?.username,
        };
      });
    return dataArray ? data : [];
  };

  const convertCompany = (dataArray) => {
    try {
      const data =
        dataArray.length > 0 &&
        dataArray.map((company) => {
          return {
            title: company?.companyName,
            value: `company_${company._id}`,
            key: `company_${company._id}`,
            children: company?.departments?.map((department) => {
              return {
                title: department?.departmentName,
                value: `department_${department._id}_company_${company._id}`,
                key: `department_${department._id}_company_${company._id}`,
                children: department?.groups?.map((group) => {
                  return {
                    title: group?.groupName,
                    value: `group_${group._id}_department_${department._id}_company_${company._id}`,
                    key: `group_${group._id}_department_${department._id}_company_${company._id}`,
                  };
                }),
              };
            }),
          };
        });
      return dataArray ? data : [];
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      try {
        const data = await getManagementApplication();
        setTotalPage(data.dataPage?.totalPages);
        const dataShowTable = convertDataTable(data.dataPage?.data);
        setListAction(dataShowTable);
        const filterCompany = data.allCompanies
          ? data.allCompanies.map((item) => {
              return {
                value: item._id,
                label: item.companyName,
              };
            })
          : false;
        setListCompany(filterCompany);

        const dataResDepartment = convertCompany(data.allCompanies || []);
        setTreeDataDepartment(dataResDepartment);

        setLoading(false);
      } catch (error) {
        message.error(t("requiredPermission"));
        setLoading(false);
        setListAction([]);
        setListCompany([]);
      }
    }
    fetchData();
  }, []);

  const onFinish = async (data) => {
    try {
      if (data.status === 2 || selectedApplication.status === 2) {
        if (data.company) {
          const ids = extractManyId(data.company);
          const dataReq = {
            company: ids.company,
            group: ids.group,
            department: ids.department,
            status: 1,
          };
          const dataResUser = await updateDepartmentUser(
            selectedApplication.createdById,
            dataReq
          );
          const dataRes = await updateApplication(data.id, { status: 3 });
          dataRes.status === 1 && dataResUser.status === 1
            ? message.success(t("updateSuccess"))
            : message.error(t("updateFail"));
        } else {
          let dataUpdate = { status: data.status };
          const dataRes = await updateApplication(data.id, dataUpdate);
          dataRes.status === 1
            ? message.success(t("updateSuccess"))
            : message.error(t("updateFail"));
        }
        handleRefreshData();
      } else {
        let dataUpdate = { status: data.status };
        if (data.company) {
          const ids = extractManyId(data.company);
          dataUpdate.company = ids.company;
          dataUpdate.department = ids.department;
        }
        if (
          (dataUpdate.status === 1 && selectedApplication.status === 1) ||
          (dataUpdate.company === selectedApplication.companyId &&
            dataUpdate.department === selectedApplication.departmentId &&
            dataUpdate.status === selectedApplication.status)
        ) {
          message.success(t("dataNotChange"));
        } else {
          const dataRes = await updateApplication(data.id, dataUpdate);
          dataRes.status === 1
            ? message.success(t("updateSuccess"))
            : message.error(t("updateFail"));
          handleRefreshData();
        }
      }
      form.resetFields();
      handleCloseDrawer();
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
      form.resetFields();
      formSearch.resetFields();
      handleCloseDrawer();
    }
  };

  const handleRefresh = async () => {
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    setListAction(dataRes.length > 0 ? dataRes : listAction);
    formSearch.resetFields();
    setPageIndex(1);
  };

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item)) {
      return;
    }
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, 1);
    setListAction(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const onPageChange = (page, page_size) => {
    setPageIndex(page);
    setPageSize(page_size);
    onPageChangeAtSearch(page, page_size);
  };

  const onPageChangeAtSearch = async (indexPage, page_size) => {
    setLoading(true);

    const params = {
      pageIndex: indexPage,
      pageSize: page_size,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, indexPage);
    setListAction(dataRes.length > 0 ? dataRes : false);
    setLoading(false);
  };

  const onEdit = (key) => {
    const dataEdit = listAction.filter((item) => item.key === key);

    setSelectedApplication(dataEdit[0]);
    let setData = {
      id: dataEdit[0].key,
    };

    setData.status = dataEdit[0].status;
    if (dataEdit[0].status === 0 || dataEdit[0].status == 2) {
      setData.company = listCompany.length
        ? extractTwoIds(dataEdit[0].departmentId, dataEdit[0].companyId)
        : undefined;
    }
    form.setFieldsValue(setData);
    setDrawerTitle(t("editApply"));
    showDrawer();
  };
  const getFormSearch = () => {
    const dataForm = formSearch.getFieldsValue();
    const ids = extractManyId(dataForm.department);
    return {
      status: dataForm.status ?? "",
      username: dataForm.username ?? "",
      company: ids.company || "",
      department: ids.department || "",
      group: ids.group || "",
    };
  };
  const handleRefreshData = async (index_page) => {
    const _params = {
      pageIndex: index_page ? index_page : indexPage,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(_params);
    setListAction(dataRes);
    setPageIndex(index_page ? index_page : indexPage);
  };
  const handleRefreshDataDelete = async (countRemove) => {
    const indexPageNew =
      listAction.length == countRemove
        ? indexPage === 1
          ? 1
          : indexPage - 1
        : indexPage;
    handleRefreshData(indexPageNew);
  };
  const onDelete = async (key) => {
    try {
      const dataRes = await deleteApplication(key);
      if (dataRes.status === 1) {
        message.success(t("deleteSuccess"));
        handleRefreshDataDelete(1);
      } else {
        message.error(t("deleteFail"));
      }
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
    }
  };

  const showModalConfirmDelete = (record) => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete(record);
      },
      onCancel() {},
    });
  };

  const getStatusString = (status) => {
    const statusObject = statusOptions.find(
      (option) => option.value === status
    );
    return statusObject
      ? { label: statusObject.label, color: statusObject.color }
      : { label: "", color: "" };
  };

  const columns = [
    {
      title: t("applyName"),
      dataIndex: "createdBy",
    },
    {
      title: t("company"),
      dataIndex: "companyName",
    },
    {
      title: t("department"),
      dataIndex: "departmentName",
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("lastUpdate"),
      dataIndex: "updatedTime",
    },
    {
      title: t("updateBy"),
      dataIndex: "updatedBy",
    },
    {
      title: t("statusApply"),
      dataIndex: "",
      render: (_, record) => {
        const obj = getStatusString(record.status);
        const previousObject = getStatusString(record.status - 1);
        const isOnBoard = record.userStatus;
        return (
          <>
            {!isOnBoard ? (
              <Tag color={obj.color} style={{ borderRadius: 5 }}>
                {obj.label}
              </Tag>
            ) : (
              <>
                <Tag color={previousObject.color} style={{ borderRadius: 5 }}>
                  {previousObject.label}
                </Tag>
                <Tag color={obj.color} style={{ borderRadius: 5 }}>
                  {obj.label}
                </Tag>
              </>
            )}
          </>
        );
      },
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) =>
        listAction.length >= 1 ? (
          <Space>
            <Tooltip title={t("applyInformation")}>
              <Button
                type="default"
                shape="circle"
                icon={<EyeOutlined />}
                size="small"
                onClick={() => handleShowModalInfomation(record.createdByInfo)}
              />
            </Tooltip>
            <Tooltip title={t("edit")}>
              <Button
                type="primary"
                shape="circle"
                icon={<EditOutlined />}
                size="small"
                onClick={() => onEdit(record.key)}
              />
            </Tooltip>
            <Tooltip title={t("delete")}>
              <Button
                type="danger"
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
                onClick={() => showModalConfirmDelete(record.key)}
              />
            </Tooltip>
          </Space>
        ) : null,
    },
  ];

  const onClose = () => {
    setSelectedApplication({});
    setVisibleForm(false);
  };

  const showDrawer = () => {
    setVisibleForm(true);
  };

  const handleCloseDrawer = () => {
    setDrawerTitle("");
    setVisibleForm(false);
    form.resetFields();
  };
  const handleClodeModalInfomation = () => {
    setShowModalInfomation(false);
  };
  const handleShowModalInfomation = async (data) => {
    setInfomationUser(data);
    setShowModalInfomation(true);
  };

  const handleDeleteSelectRows = async () => {
    confirm({
      title: (
        <Trans
          i18nKey="confirmDeleteManyApply"
          values={{ count: selectedRowKeys.length }}
        />
      ),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        OnDeleteSelectRows();
      },
      onCancel() {},
    });
  };

  const OnDeleteSelectRows = async () => {
    try {
      setLoadingDeleteRows(true);

      const dataRes = await deleteManyApplication({
        data: { ids: selectedRowKeys },
      });

      if (dataRes.status === 200) {
        message.success(
          <Trans
            i18nKey="deleteSuccessManyApply"
            values={{ count: dataRes.data.deletedCount }}
          />
        );
        handleRefreshDataDelete(dataRes.data.deletedCount);
      } else {
        message.error(t("deleteFail"));
      }

      setSelectedRowKeys([]);
      setLoadingDeleteRows(false);
    } catch (error) {
      setLoadingDeleteRows(false);
      message.error(t("permisstionDeniedAction"));
    }
  };

  const renderNextStepsByStatus = (status) => {
    switch (status) {
      case 0:
        return [
          { value: 0, label: t("penddingApply"), color: "#800080" },
          { value: -1, label: t("rejectApply"), color: "#f50" },
          { value: 1, label: t("interviewing"), color: "#87d068" },
        ];
      case 1:
        return [
          { value: 1, label: t("interviewing"), color: "#003df5" },
          { value: -2, label: t("Unsatisfactory"), color: "#f50" },
          { value: 2, label: t("qualified"), color: "#25d366" },
        ];
      default:
        break;
    }
  };
  const renderStepsByStatus = (status) => {
    switch (status) {
      case -2:
        return [
          {
            title: t("penddingApply"),
            icon: <UserOutlined />,
          },
          {
            title: t("interviewing"),
            icon: <SolutionOutlined />,
          },
          {
            title: t("Unsatisfactory"),
            icon: <MehOutlined />,
            status: "error",
          },
        ];
      case -1:
        return [
          {
            title: t("rejectApply"),
            icon: <MehOutlined />,
            status: "error",
          },
          {
            title: t("interviewing"),
            icon: <SolutionOutlined />,
          },
          {
            title: t("qualified"),
            icon: <SmileOutlined />,
          },
        ];
      case 0:
        return [
          {
            title: t("penddingApply"),
            icon: <UserOutlined />,
          },
          {
            title: t("interviewing"),
            icon: <SolutionOutlined />,
          },
          {
            title: t("qualified"),
            icon: <SmileOutlined />,
          },
          {
            title: t("acceptedTheJob"),
            icon: <CheckSquareOutlined />,
          },
        ];
      case 1:
        return [
          {
            title: t("penddingApply"),
            icon: <UserOutlined />,
          },
          {
            title: t("interviewing"),
            icon: <SolutionOutlined />,
          },
          {
            title: t("qualified"),
            icon: <SmileOutlined />,
          },
          {
            title: t("acceptedTheJob"),
            icon: <CheckSquareOutlined />,
          },
        ];
      case 2:
        return [
          {
            title: t("penddingApply"),
            icon: <UserOutlined />,
          },
          {
            title: t("interviewing"),
            icon: <SolutionOutlined />,
          },
          {
            title: t("qualified"),
            icon: <SmileOutlined />,
          },
          {
            title: t("acceptedTheJob"),
            icon: <CheckSquareOutlined />,
          },
        ];
      case 3:
        return [
          {
            title: t("penddingApply"),
            icon: <UserOutlined />,
          },
          {
            title: t("interviewing"),
            icon: <SolutionOutlined />,
          },
          {
            title: t("qualified"),
            icon: <SmileOutlined />,
          },
          {
            title: t("acceptedTheJob"),
            icon: <CheckSquareOutlined />,
          },
        ];
      default:
        break;
    }
  };
  const renderCurrentByStatus = (status) => {
    switch (status) {
      case -2:
        return 2;
      case -1:
        return 0;
      case 0:
        return 0;
      case 1:
        return 1;
      case 2:
        return 2;
      case 3:
        return 3;
      default:
        return;
    }
  };

  return (
    <>
      <div className="page-content">
        <Card bordered={false}>
          <Row>
            <Col xs={12}>
              <Form form={formSearch} layout="vertical" autoComplete="off">
                <Row>
                  <Col sm={3}>
                    <Form.Item
                      name="username"
                      label={t("applyName") + ":"}
                      rules={[
                        {
                          required: false,
                          message: "Vui lòng nhập tên ứng viên!",
                        },
                        {
                          type: "string",
                          min: 1,
                        },
                      ]}
                    >
                      <Input
                        placeholder={t("placeHolderApplyName")}
                        allowClear={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={4}>
                    <Form.Item
                      name="department"
                      label={t("companyNameAndDepartment") + ":"}
                    >
                      <TreeSelect
                        showSearch
                        treeNodeFilterProp="title"
                        style={{ width: "100%" }}
                        placeholder={t("PlaceHolderselectCompanyAndDepartment")}
                        allowClear
                        onChange={() => handleSearch()}
                      >
                        {treeDataDepartment &&
                          treeDataDepartment?.map((data) => {
                            return (
                              <TreeNode
                                key={data.key}
                                value={data.value}
                                title={data.title}
                              >
                                {data.children.length > 0
                                  ? data.children.map((child) => {
                                      return (
                                        <TreeNode
                                          key={child.key}
                                          value={child.value}
                                          title={child.title}
                                        ></TreeNode>
                                      );
                                    })
                                  : null}
                              </TreeNode>
                            );
                          })}
                      </TreeSelect>
                    </Form.Item>
                  </Col>
                  <Col sm={4}>
                    <Form.Item name="status" label={t("status") + ":"}>
                      <Select
                        mode="multiple"
                        placeholder={t("placeHolderselectStatus")}
                        style={{ width: "100% " }}
                        allowClear
                        onChange={() => handleSearch()}
                        options={statusOptions}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item className="">
                  <Space>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => handleSearch()}
                    >
                      {t("search")}
                    </Button>

                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => handleRefresh()}
                    >
                      {t("reload")}
                    </Button>
                    <Button
                      disabled={selectedRowKeys.length === 0}
                      loading={loadingDeleteRows}
                      type="danger"
                      htmlType="button"
                      onClick={() => handleDeleteSelectRows()}
                    >
                      {t("delete")}
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Card>
        <div>
          <Col>
            <Drawer
              title={drawerTitle}
              placement={"right"}
              width={"50%"}
              minWidth="fit-content"
              onClose={onClose}
              open={visibleForm}
              bodyStyle={{
                paddingBottom: 80,
              }}
              style={{ marginTop: "70px" }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                <Row>
                  <Col hidden={true}>
                    <Form.Item name="id" label="Id">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item label={t("status")}>
                      <Steps
                        current={renderCurrentByStatus(
                          selectedApplication.status
                        )}
                        items={renderStepsByStatus(selectedApplication.status)}
                      />
                    </Form.Item>

                    {selectedApplication.status === 0 ||
                    selectedApplication.status === 1 ? (
                      <Form.Item name="status" label={t("updateStatus")}>
                        <Select
                          onChange={(value) => {
                            setSelectedApplication({
                              ...selectedApplication,
                              showSelectDepartment: value === 2,
                            });
                          }}
                          style={{ width: "100%" }}
                          options={renderNextStepsByStatus(
                            selectedApplication.status
                          )}
                        />
                      </Form.Item>
                    ) : null}

                    {selectedApplication.status === 0 ||
                    selectedApplication.status === 2 ||
                    selectedApplication.showSelectDepartment ? (
                      <Form.Item
                        name="company"
                        label={
                          selectedApplication.status === 2 ||
                          selectedApplication.showSelectDepartment
                            ? t("workgroup")
                            : t("workGroupApply")
                        }
                      >
                        <TreeSelect
                          showSearch
                          treeNodeFilterProp="title"
                          style={{ width: "100%" }}
                          placeholder={
                            selectedApplication.showSelectDepartment
                              ? t("selectGroup")
                              : t("selectDepartment")
                          }
                          allowClear={false}
                        >
                          {treeDataDepartment &&
                            treeDataDepartment?.map((data) => {
                              const disableChildren =
                                data.children.length === 0;
                              return (
                                <TreeNode
                                  key={data.key}
                                  value={data.value}
                                  title={data.title}
                                  disabled={!disableChildren}
                                >
                                  {!disableChildren
                                    ? data.children.map((child) => {
                                        const disableChildrenOfChild =
                                          child.children.length === 0;
                                        return (
                                          <TreeNode
                                            key={child.key}
                                            value={child.value}
                                            title={child.title}
                                            disabled={
                                              selectedApplication.showSelectDepartment &&
                                              !disableChildrenOfChild
                                            }
                                          >
                                            {(selectedApplication.status ===
                                              2 ||
                                              selectedApplication.showSelectDepartment) &&
                                            !disableChildrenOfChild
                                              ? child.children.map(
                                                  (childOfChild) => {
                                                    return (
                                                      <TreeNode
                                                        key={childOfChild.key}
                                                        value={
                                                          childOfChild.value
                                                        }
                                                        title={
                                                          childOfChild.title
                                                        }
                                                      ></TreeNode>
                                                    );
                                                  }
                                                )
                                              : null}
                                          </TreeNode>
                                        );
                                      })
                                    : null}
                                </TreeNode>
                              );
                            })}
                        </TreeSelect>
                      </Form.Item>
                    ) : null}
                  </Col>
                </Row>

                <Form.Item className="mt-2">
                  <Space>
                    {selectedApplication.status >= 0 &&
                    selectedApplication.status != 3 ? (
                      <Button type="primary" htmlType="submit">
                        {t("save")}
                      </Button>
                    ) : null}

                    <Button type="danger" onClick={handleCloseDrawer}>
                      {t("close")}
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Drawer>
          </Col>
        </div>
        <DataTable
          listData={listAction}
          pageSize={pageSize}
          columns={columns}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </div>
      <ModalInfomation
        showModal={showModalInfomation}
        handleClodeModal={handleClodeModalInfomation}
        infomationUser={infomationUser}
      />
    </>
  );
};
export default ApplicationManagement;
